/**
 *  更新state状态
 * */
export enum UPDATE_STATE_TYPE {
    PRE_INFO = 'PRE_INFO', // 使用平台资料
    BASE_INFO = 'BASE_INFO', // 使用基础资料  基础资料使用此状态表示加载完成
    HAS_EDITED = 'HAS_EDITED', // 编辑过
    CLEAR = 'CLEAR', // 清空状态
}

/**
 *  页面表单状态
 * */
export enum FORM_TYPE {
    CREATE = 'create', // 创建
    EDIT = 'edit', // 编辑 打开编辑页用的字段，后续到页面变成了preEdit（后续可统一）
    PERFECT = 'perfect', // 完善 打开批量商品完善页编辑用的字段，后续到页面变成了prePerfect（后续可统一）
    COPY = 'copy', // 复制
    /** 预编辑（平台资料编辑）单页面编辑 */
    PRE_EDIT = 'preEdit',
    /** 预完善（批量发布完善）单页面编辑 */
    PRE_PERFECT = 'prePerfect',
}

/**
 *  日志查看
 * */
export const GYL_LOG_LOOK = 'LOG_LOOK'

export const FIXED_VALUE = 'FIXED_VALUE'
export const RULE_VALUE = 'RULE_VALUE'

export const VALUE_TYPES = [
    {
        value: FIXED_VALUE,
        label: '固定日期',
    },
    {
        value: RULE_VALUE,
        label: '规则日期',
    },
]

// 生产日期 需要特殊处理
export const PRODUCTION_DATE = 'PRODUCTION_DATE'
